<template>
  <BusinessesHeader>
    <TableScopeNotice>{{ notice }}</TableScopeNotice>
    <UnpaidTable/>
  </BusinessesHeader>
</template>

<script>
    import BusinessesHeader from "@/components/BusinessesHeader.vue";
    import UnpaidTable from "@/components/tables/UnpaidTable.vue";
    import TableScopeNotice from "@/components/TableScopeNotice.vue";
    import {BUSINESS_TABS} from "@/components/businessTabs";

    export default {
      name: 'UnpaidView',
      components: {
        UnpaidTable,
        TableScopeNotice,
        BusinessesHeader
      },
      computed: {
        notice() {
          return BUSINESS_TABS.find(tab => tab.key === 'unpaid')?.notice;
        }
      }
    }
</script>

<style lang="stylus" scoped>
  @require '~/src/common/style/common.styl';
  h1
    color: THEME_COLOR_PRIMARY
    span
      color: THEME_COLOR_PRIMARY_FADDED
</style>

<style lang="stylus">
  main
    align-content start
</style>